import { Typography, Container } from '@mui/material';
import { seoArticlesList_seoArticlesList_SEOArticlesListSuccess_seoArticlesList as SEOArticlesList } from '@/__generated__/seoArticlesList';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';
import { Carousel } from '@/components/common/Carousel';
import { useResponsive } from '@/components/hooks/useResponsive';
import { ArticleCard } from '@/components/common/ArticleSection/ArticleCard';

type ArticleSectionProps = {
  articles: SEOArticlesList['articles'];
};

export const ArticleSection = ({ articles }: ArticleSectionProps) => {
  const { isSmallViewport } = useResponsive();
  const { segmentNameSingular } = usePageAttributes();

  if (articles.length <= 0) {
    return null;
  }

  return (
    <Container
      maxWidth="lg"
      sx={{
        pt: { xs: 4, sm: 0 },
        mb: { xs: 6, md: 12 },
        mt: { sm: 6, md: 12 },
        position: 'relative',
        px: { xl: 0 },
      }}>
      <Typography
        component="h2"
        variant={isSmallViewport ? 'h1' : 'display3'}
        mb={{ xs: 4, sm: 6 }}
        mt={0}>
        {segmentNameSingular ? `${segmentNameSingular} Articles` : 'Related articles'}
      </Typography>
      <Carousel
        controlVariant={isSmallViewport ? 'none' : 'topRight'}
        showProgressIndicator={isSmallViewport}
        itemsPerView={isSmallViewport ? 1 : 3}>
        {articles.map((article) => {
          if (!article.largeImage?.imageUrl) return null;

          return (
            <ArticleCard
              key={article.title}
              url={article.url}
              imageUrl={article.largeImage.imageUrl}
              title={article.title}
              description={article.description}
              articleCreateDate={article.createDate}
            />
          );
        })}
      </Carousel>
    </Container>
  );
};

export default ArticleSection;
